import { render, staticRenderFns } from "./course-drawer.vue?vue&type=template&id=d2c2e5f8&"
import script from "./course-drawer.vue?vue&type=script&lang=js&"
export * from "./course-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports